import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Thin wrapper over TanStack Query that preserves the original hook shape
 * ({ data, error, loading, reload }) so every page works unchanged — while
 * gaining a shared cache, in-flight dedupe, no stale-response race, and global
 * invalidation via src/lib/invalidate.ts.
 */
export function useApi<T>(path: string | null, opts?: { refetchInterval?: number | false }) {
  const q = useQuery<T>({
    queryKey: [path],
    queryFn: () => api.get<T>(path as string),
    enabled: !!path,
    refetchInterval: opts?.refetchInterval,
  });
  return {
    data: (q.data ?? null) as T | null,
    error: q.error ? (q.error as Error).message : null,
    loading: q.isLoading,
    reload: () => q.refetch(),
  };
}
